import showdown, { ConverterOptions } from 'showdown';
import { reactUrlFormatter } from './reactUrlFormatter';
import { urlCheck } from './urlFormatter';

export const text = (value: any): string => {
	if (typeof value === 'string') return value;
	if (['number', 'boolean'].includes(typeof value)) return value.toString();
	return JSON.stringify(value, undefined, 2);
};

export const addsHtmlSupports = (value: string) => {
	// adds <br> and <br/> support
	return value.replace(/&lt;br\/?&gt;/g, '<br/>');
};

const addsBlank = (text: string) =>
	text.replace(/<a href/g, '<a target="_blank" href');

export const parseText = async (
	text: string,
	options: ConverterOptions = {},
): Promise<string> => {
	const converter = new showdown.Converter({
		literalMidWordUnderscores: true,
		simpleLineBreaks: true,
		emoji: true,
		strikethrough: true,
		omitExtraWLInCodeBlocks: true,
		tables: true,
		...options,
	});

	const converted = addsBlank(converter.makeHtml(addsHtmlSupports(text)));

	if (urlCheck(converted)) {
		const formattedConverted = await reactUrlFormatter(converted);

		return formattedConverted;
	} else {
		return converted;
	}
};
